import { useEffect, useState } from 'react';
import { useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useFormContext } from 'shared-widget-components/src/providers/FormContextProvider';
import { subscribe } from '../../../services/SubscribeService';

export const useSubscribeForm = ({ setSuccess }: { setSuccess: (value: boolean) => void }) => {
  const { t } = useTranslation();
  const { control } = useFormContext();

  //@ts-ignore
  const isAdmin = window.isAdminPage;

  const [nameError, setNameError] = useState('');
  const [emailError, setEmailError] = useState('');
  // adatkezelési szabályzat checkboxhoz tartozó hibaüzenet
  const [dataPolicyError, setDataPolicyError] = useState('');
  // felhasználó életkorát jelölő checkboxhoz tartozó hibaüzenet
  const [customerAgeError, setCustomerAgeError] = useState('');

  const name = useWatch({ control, name: 'name' });
  const email = useWatch({ control, name: 'email' });
  const dataPolicy = useWatch({ control, name: 'dataPolicy' });
  const winegroupDataPolicy = useWatch({ control, name: 'winegroupDataPolicy' });
  const customerAge = useWatch({ control, name: 'customerAge' });

  // Ha változik a form, akkor a hibák kezelése
  useEffect(() => {
    if (name) setNameError('');
    if (email) setEmailError('');
    if (dataPolicy) setDataPolicyError('');
    if (customerAge) setCustomerAgeError('');
  }, [name, email, dataPolicy, customerAge]);

  const submitForm = async () => {
    if (isAdmin) return;

    // Email validáció regex használatával
    const validEmail = isValidEmail(email);

    // Ha minden mező kitöltött, akkor nincs hiba
    if (name && email && validEmail && dataPolicy && customerAge) {
      try {
        // nav a success oldalra
        setSuccess(true);
        // feliratkozás a megfelelő listákra
        await subscribe({ email, firstName: name, subscribeToWineGroup: winegroupDataPolicy ?? false, subscribeToWebshop: dataPolicy });
      } catch (error) {
        throw new Error(error);
      }

      return;
    }

    // Ha nincs név
    if (!name) setNameError(t('subscribeWidget.nameError'));
    // Ha nincs email
    if (!email) setEmailError(t('subscribeWidget.emailError'));
    // Ha nincs valid email
    if (email && !validEmail) setEmailError(t('subscribeWidget.emailInvalidError'));
    // Ha nincs dataPolicy
    if (!dataPolicy) setDataPolicyError(t('subscribeWidget.checkbox1Error'));
    // Ha nincs customerAge
    if (!customerAge) setCustomerAgeError(t('subscribeWidget.checkbox3Error'));
  };

  // https://regexr.com/3e48o
  const isValidEmail = (email: string) => {
    // Regular expression for basic email validation
    const emailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g;
    return emailRegex.test(email);
  };

  return { nameError, emailError, dataPolicyError, customerAgeError, submitForm };
};
